// extracted by mini-css-extract-plugin
export default {"header":"KIzGAlyPCiWlLh4AhhGS","nativeHeader":"FKHemwko_I61GqfNuxZC","saveExitButton":"m6wpxC1hZTBqbkJKAK5w"};